import { API } from '@base/core';
import { Form } from '@editors/form-editor';
import { useQuery } from 'react-query';

export function useGetForms<T extends Form>(campaignId: string) {
  return useQuery(['campaigns', campaignId, 'forms'], async () => {
    return (await API.campaigns.getForms(campaignId)) as T[];
  });
}
